var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.notification !== undefined)?_c('v-alert',{attrs:{"dismissible":"","type":"success"}},[_vm._v(" "+_vm._s(_vm.notification)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }